import mimeDb from './mime-db.json';
/*
    Utilities are organized by type -- (i.e. boolean, string, array)
    When a utility doesn't apply to a type it can fall into other
    categories (as needed)
*/
/* --- array  --- */
/* --- boolean --- */
/* --- dictionary --- */
/* --- int --- */
export function formatNumberIntoCurrency(value) {
    try {
        return "$" + value.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    }
    catch (e) {
        return '';
    }
}
/* --- string --- */
/** Returns '$1,234' from '1234' */
export function formatStringIntoCurrency(value) {
    var parsedString = parseFloat(value).toFixed(2);
    return "$" + parsedString.replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
}
/** Returns 123.456.1234 from 1234561234 */
export function formatStringIntoPhoneNumber(number) {
    try {
        var areaCode = number.substring(0, 3);
        var number1 = number.substring(3, 6);
        var number2 = number.substring(6, 11);
        return areaCode + "." + number1 + "." + number2;
    }
    catch (e) {
        return '';
    }
}
/** Returns '1234' from '$1,234' */
export function removeCurrencySymbols(value) {
    return value ?
        String(value).replace(/,/g, '').replace(/\$/g, '') :
        '0';
}
export function formatCurrencyIntoNumber(value) {
    var data = value || '$0.00';
    var num = +data.toString().replace(/(\$|,)/g, '');
    return +num.toFixed(2);
}
export function formatStringIntoNumber(value) {
    return value.replace(/[^\d.\s]+/g, '');
}
export function stringTrimmer(value) {
    return typeof value === 'string' ? value.trim() : '';
}
export function getFileName(str) {
    var _a;
    return (_a = str.split('\\').pop()) === null || _a === void 0 ? void 0 : _a.split('/').pop();
}
export function getFileNameNoExt(filePath) {
    var fileName = getFileName(filePath);
    var baseName = fileName === null || fileName === void 0 ? void 0 : fileName.substring(0, fileName.lastIndexOf('.'));
    return baseName;
}
export function fileIsPdf(fileName) {
    var pdfPattern = /\.pdf?$/i;
    return pdfPattern.test(fileName);
}
export function fileIsTiff(fileName) {
    var tiffPattern = /\.tiff?$/i;
    return tiffPattern.test(fileName);
}
export function getFileExt(fileName) {
    return fileName.split('.').pop();
}
export function signedUrlIsPdf(signedUrl) {
    var fileKeyArray = signedUrl.match(/.+?(?=\?)/g) || [];
    var fileKey = fileKeyArray[0];
    return !!fileKey.endsWith('.pdf');
}
export { mimeDb };
export function getMimeTypeForFileName(fileName) {
    var _a, _b;
    // TODO: allow to handle RTS invoice files that don't have name, only key, try-catch temporarily to stop crashing.
    var extension = ((_b = (_a = fileName === null || fileName === void 0 ? void 0 : fileName.split('.')) === null || _a === void 0 ? void 0 : _a.pop()) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || 'pdf';
    var foundType;
    for (var _i = 0, _c = Object.entries(mimeDb); _i < _c.length; _i++) {
        var _d = _c[_i], key = _d[0], val = _d[1];
        if ((val).extensions.includes(extension)) {
            foundType = key;
            break;
        }
    }
    return foundType;
}
export function validateEmail(email) {
    // eslint-disable-next-line max-len, no-useless-escape
    var validEmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return validEmailRegex.test(email.toLowerCase());
}
/* --- dates --- */
/**
 * inputs of '2020-04-17T03:24:00' and '2020-06-20T18:59:23' return {days: 64, hours: 15, minutes: 35} */
export function calculateDaysHoursMinutesBetweenTwoDates(startDate, endDate) {
    var MILLISECONDS_IN_A_SECOND = 1000;
    var SECONDS_IN_A_DAY = 86400;
    var SECONDS_IN_AN_HOUR = 3600;
    var SECONDS_IN_A_MINUTE = 60;
    var totalSeconds = Math.abs(startDate.getTime() - endDate.getTime()) / MILLISECONDS_IN_A_SECOND;
    var wholeDays = Math.floor(totalSeconds / SECONDS_IN_A_DAY);
    var secondsLeftAfterWholeDays = totalSeconds - (wholeDays * SECONDS_IN_A_DAY);
    var wholeHours = Math.floor(secondsLeftAfterWholeDays / SECONDS_IN_AN_HOUR);
    var secondsLeftAfterWholeHours = Math.round(secondsLeftAfterWholeDays - (wholeHours * SECONDS_IN_AN_HOUR));
    var leftoverMinutes = Math.round(secondsLeftAfterWholeHours / SECONDS_IN_A_MINUTE);
    return { days: wholeDays, hours: wholeHours, minutes: leftoverMinutes };
}
/* --- misc --- */
/** This function applies a timeout on a synchronous function's execution */
export function debounce(func, delay) {
    var timer;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timer);
        timer = setTimeout(function () { return func.apply(void 0, args); }, delay);
    };
}
/** This function applies a timeout on an asynchronous function's execution */
export function debounceAsync(func, delay) {
    var timer;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timer);
        return new Promise(function (resolve) {
            timer = setTimeout(function () { return resolve(func.apply(void 0, args)); }, delay);
        });
    };
}
/** This function applies a timeout on an asynchronous function's execution. If the parameter you are debouncing is
 * currently still waiting to execute, it will refresh the timeout period. If it is not currently waiting to execute,
 * it will add it to the currentlyRunningPromises array that you have specified. If the timeout period finishes without
 * another execution of the function, it will remove it from the currentlyRunningPromises and execute the promise.
 * This type of functionality comes in handy when uses are quickly jumping between inputs on a form which use the same
 * API to update those values. Using this works well with onChange events, which allows you to eliminate the onBlur
 * type of functionality where you are checking if anything changed.
 */
export function debounceAsyncWithParameters(func, delay, parameterToDelay, currentlyRunningPromises) {
    return function () {
        var matchingUpdateField = currentlyRunningPromises.findIndex(function (t) { return t.field === parameterToDelay; });
        if (matchingUpdateField > -1) {
            clearTimeout(currentlyRunningPromises[matchingUpdateField].timer);
            return new Promise(function (resolve) {
                currentlyRunningPromises[matchingUpdateField].timer = setTimeout(function () {
                    var executeAndCleanup = function () {
                        currentlyRunningPromises.splice(1, matchingUpdateField);
                        return func();
                    };
                    resolve(executeAndCleanup());
                }, delay);
            });
        }
        else {
            return new Promise(function (resolve) {
                currentlyRunningPromises.push({ field: parameterToDelay, timer: setTimeout(function () { return _noop; }, 10000) });
                var index = currentlyRunningPromises.length - 1;
                var executeAndCleanup = function () {
                    currentlyRunningPromises.splice(1, index);
                    return func();
                };
                currentlyRunningPromises[index].timer = setTimeout(function () { return resolve(executeAndCleanup()); }, delay);
            });
        }
    };
}
export function deferPromise() {
    var defer = {};
    defer.promise = new Promise(function (resolve, reject) {
        defer.resolve = resolve;
        defer.reject = reject;
    });
    return defer;
}
/** NOOP */
// eslint-disable-next-line @typescript-eslint/no-empty-function
export function _noop() { }
export function massageFileData(files) {
    return files.map(function (file) { return ({
        name: getFileName(file.Key),
        key: file.Key,
    }); });
}
export function fileExists(key, files) {
    if (Array.isArray(files)) {
        var fileIndex = files.findIndex(function (file) { return file.key === key; });
        if (fileIndex > -1)
            return true;
    }
    return false;
}
export function getPermissionStatus(permissions, name) {
    var permission = permissions === null || permissions === void 0 ? void 0 : permissions.find(function (p) { return p.name === name; });
    return permission ? permission.status === 'active' : false;
}
// eslint-disable-next-line
export function serializeArray(form) {
    var serialized = [];
    for (var i = 0; i < form.elements.length; i++) {
        var field = form.elements[i];
        if (!field.name || field.disabled || field.type === 'file' ||
            field.type === 'reset' || field.type === 'submit' ||
            field.type === 'button')
            continue;
        if (field.type === 'select-multiple') {
            for (var n = 0; n < field.options.length; n++) {
                if (!field.options[n].selected)
                    continue;
                serialized.push({
                    name: field.name,
                    value: field.options[n].value,
                });
            }
        }
        else if ((field.type !== 'checkbox' && field.type !== 'radio') ||
            field.checked) {
            serialized.push({
                name: field.name,
                value: field.value,
            });
        }
    }
    return serialized;
}
